import { render, staticRenderFns } from "./CommunityDetail.vue?vue&type=template&id=40e1212b&scoped=true"
import script from "./CommunityDetail.vue?vue&type=script&lang=js"
export * from "./CommunityDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityDetail.vue?vue&type=style&index=0&id=40e1212b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1212b",
  null
  
)

export default component.exports